import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { Route, Switch } from 'react-router-dom';
import { Screen as NotFoundScreen } from '../NotFound/index.js';
import { Screen as AccountScreen } from './Account/index.js';
import { Screen as AccountClosedScreen } from './AccountClosed/index.js';
import { Screen as ApplyCreditVoucherScreen } from './ApplyCreditVoucher/index.js';
import { Screen as ConfirmEmailScreen } from './ConfirmEmail/index.js';
import { Screen as ContactScreen } from './Contact/index.js';
import { Screen as CookiePolicyScreen } from './CookiePolicy/index.js';
import { Screen as DataSubjectAccessRequestScreen } from './DataSubjectAccessRequest/index.js';
import { Screen as DisclaimerScreen } from './Disclaimer/index.js';
import { Screen as EmailConfirmedScreen } from './EmailConfirmed/index.js';
import { Screen as ForgotPasswordEmailSentScreen } from './ForgotPasswordEmailSent/index.js';
import { Screen as LogoutScreen } from './Logout/index.js';
import { Screen as PairScreen } from './Pair/index.js';
import { Screen as PairedScreen } from './Paired/index.js';
import { Screen as PasswordHasBeenResetScreen } from './PasswordHasBeenReset/index.js';
import { Screen as PersonScreen } from './Person/index.js';
import { Screen as PrivacyPolicyScreen } from './PrivacyPolicy/index.js';
import { Screen as TermsOfServiceScreen } from './TermsOfService/index.js';
import { Screen as VoucherAppliedScreen } from './VoucherApplied/index.js';

export const Screen = () => {
  return (
    <Switch>
      <Route path={rootRoutes.app.confirmEmail.main.route} component={ConfirmEmailScreen} exact={true} />
      <Route path={rootRoutes.app.account.main.route} component={AccountScreen} />
      <Route path={rootRoutes.app.pair.main.route} component={PairScreen} />
      <Route path={rootRoutes.app.status.paired.main.route} component={PairedScreen} />
      <Route path={rootRoutes.app.voucher.main.route} component={ApplyCreditVoucherScreen} />
      <Route path={rootRoutes.app.status.voucherApplied.main.route} component={VoucherAppliedScreen} />
      <Route path={rootRoutes.app.persons.person.route} component={PersonScreen} />
      <Route path={rootRoutes.app.privacyPolicy.main.route} component={PrivacyPolicyScreen} />
      <Route path={rootRoutes.app.termsOfService.main.route} component={TermsOfServiceScreen} />
      <Route path={rootRoutes.app.cookiePolicy.main.route} component={CookiePolicyScreen} />
      <Route path={rootRoutes.app.disclaimer.main.route} component={DisclaimerScreen} />
      <Route path={rootRoutes.app.dsar.main.route} component={DataSubjectAccessRequestScreen} />
      <Route path={rootRoutes.app.contact.main.route} component={ContactScreen} />
      <Route path={rootRoutes.app.status.emailConfirmed.main.route} component={EmailConfirmedScreen} />
      <Route path={rootRoutes.app.status.accountClosed.main.route} component={AccountClosedScreen} />
      <Route
        path={rootRoutes.app.status.forgotPasswordEmailSent.main.route}
        component={ForgotPasswordEmailSentScreen}
      />
      <Route
        path={rootRoutes.app.status.passwordHasBeenReset.main.route}
        component={PasswordHasBeenResetScreen}
      />
      <Route path={rootRoutes.app.logout.main.route} component={LogoutScreen} exact={true} />
      <Route
        component={() => {
          return <NotFoundScreen />;
        }}
      />
    </Switch>
  );
};
